import PropTypes from "prop-types";

import {
  FlexContainers,
  Heading6,
  Modal,
  Paragraph2,
  SmallButton,
  WrapperContainer
} from "../../../components";
import MarketsTabModalTable from "./MarketsTabModalTable";
import { t } from "../../../services";
import { colors, strCode } from "../../../consts";
import { useCallback, useState } from "react";

const MarketsTabModal = ({ markets, isActive, onModalClose, onSavingMarkets }) => {
  const [selectedMarkets, setSelectedMarkets] = useState([]);

  const isMarketSelected = useCallback(
    (id) => {
      return selectedMarkets.some((market) => market.id === id);
    },
    [selectedMarkets]
  );

  const onMarketSelecting = useCallback(
    (market) => {
      if (isMarketSelected(market.id)) {
        setSelectedMarkets(
          selectedMarkets.filter((selectedMarket) => selectedMarket.id !== market.id)
        );
      } else {
        setSelectedMarkets([...selectedMarkets, market]);
      }
    },
    [selectedMarkets]
  );

  const saveMarkets = () => {
    onSavingMarkets(selectedMarkets);
    setSelectedMarkets([]);
    onModalClose();
  };

  return (
    <Modal
      id="markets-tab-modal"
      active={isActive}
      closable={false}
      modalHeader={<Heading6>{t(strCode.ADD_MARKET_TITLE)}</Heading6>}
      preventOverflow>
      <WrapperContainer
        Container={FlexContainers.FlexColumnStart}
        width={498}
        gap={18}
        alignItems="start">
        <Paragraph2 style={{ color: colors.RAISIN_80 }}>
          {t(strCode.CHOOSE_MARKET_FROM_LIST)}
        </Paragraph2>

        <MarketsTabModalTable
          markets={markets}
          isMarketSelected={isMarketSelected}
          onMarketSelecting={onMarketSelecting}
        />

        <WrapperContainer Container={FlexContainers.FlexRowEnd} mt={24} width="100%" gap={8}>
          <SmallButton secondary secondaryBold onClick={onModalClose}>
            {t(strCode.CANCEL_BTN)}
          </SmallButton>

          <SmallButton onClick={saveMarkets}>{t(strCode.DONE_BTN)}</SmallButton>
        </WrapperContainer>
      </WrapperContainer>
    </Modal>
  );
};

MarketsTabModal.propTypes = {
  markets: PropTypes.arrayOf(
    PropTypes.shape({
      activeAppTypes: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
      activeUserCount: PropTypes.number.isRequired,
      country: PropTypes.string.isRequired,
      market: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  isActive: PropTypes.bool.isRequired,
  onModalClose: PropTypes.func.isRequired,
  onSavingMarkets: PropTypes.func.isRequired
};

export default MarketsTabModal;
